import { apiClient } from './client';

export interface SchoolYear {
  id: number;
  code: string;
  startingDate: string;
  endingDate: string;
  isCurrent: boolean;
  createdAt: string | null;
  updatedAt: string | null;
}

export interface CreateSchoolYearData {
  code: string;
  startingDate: string;
  endingDate: string;
}

export interface UpdateSchoolYearData {
  startingDate?: string;
  endingDate?: string;
}

export const schoolYearsApi = {
  async getAll(): Promise<SchoolYear[]> {
    const response = await apiClient.get<SchoolYear[]>('/api/school-years');
    return response.data;
  },

  async getById(id: number): Promise<SchoolYear> {
    const response = await apiClient.get<SchoolYear>(`/api/school-years/${id}`);
    return response.data;
  },

  async create(data: CreateSchoolYearData): Promise<SchoolYear> {
    const response = await apiClient.post<SchoolYear>('/api/school-years', data);
    return response.data;
  },

  async update(id: number, data: UpdateSchoolYearData): Promise<SchoolYear> {
    const response = await apiClient.put<SchoolYear>(`/api/school-years/${id}`, data);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await apiClient.delete(`/api/school-years/${id}`);
  },
};
